var _g, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 129,
    viewBox: "0 0 124 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1620_26567)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.0044,
    y: 97.0352,
    width: 67.1559,
    height: 6.64267,
    fill: "#1B3554"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5459,
    y: 40.5723,
    width: 67.1559,
    height: 43.7309,
    fill: "#E0E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5459 40.5723V106.999H17.7144V66.8311L28.5459 40.5723Z",
    fill: "#A0AAB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7017 40.5723V106.445H105.992V66.8311L95.7017 40.5723Z",
    fill: "#A0AAB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2617 88.6604H52.3075C50.6832 88.6604 47.2917 88.6604 47.2917 88.6604H27.314C27.314 87.4528 27.314 80.9151 27.314 80.9151L27.314 76.6904C27.3139 78.8027 27.314 71.2865 27.314 70.0789V16.2101C27.314 15.0025 28.6308 14.0234 30.2552 14.0234H93.2617C94.886 14.0234 96.2029 15.0025 96.2029 16.2101V86.4738C96.2029 87.6814 94.886 88.6604 93.2617 88.6604Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -8.64118e-06 1 52.8979 44.2861)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 15.94,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45936e-08 -8.64118e-06 1 52.814 47.6611)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.26666,
    height: 8.44947,
    rx: 2,
    transform: "matrix(1 0 -8.60798e-06 1 42.4692 42.6963)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -8.64118e-06 1 52.8979 29.6963)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 15.94,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45936e-08 -8.64118e-06 1 52.814 33.0713)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8.26666,
    height: 8.44947,
    rx: 2,
    transform: "matrix(1 0 -8.60799e-06 1 42.4692 28.1064)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45935e-08 -8.64118e-06 1 52.8979 58.877)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 15.94,
    height: 1.58094,
    rx: 0.790472,
    transform: "matrix(1 -3.45936e-08 -8.64118e-06 1 52.814 62.252)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.26666,
    height: 8.44947,
    rx: 2,
    transform: "matrix(1 0 -8.60798e-06 1 42.4692 57.2871)",
    fill: "#C9D1DA",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7144 66.5898H37.0282C38.5238 66.5898 39.7362 67.8022 39.7362 69.2978C39.7362 73.0367 42.7672 76.0677 46.5061 76.0677H60.6287H74.469C78.2079 76.0677 81.2389 73.0367 81.2389 69.2978C81.2389 67.8022 82.4513 66.5898 83.9469 66.5898H105.992V105.152C105.992 108.007 103.678 110.321 100.823 110.321H22.8834C20.0286 110.321 17.7144 108.007 17.7144 105.152V66.5898Z",
    fill: "#DAE2EC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1620_26567)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.75,
    cx: 99.5844,
    cy: 88.8333,
    rx: 15.1556,
    ry: 15.5,
    transform: "rotate(-176.081 99.5844 88.8333)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.073 79.6823L100.889 92.5706L97.8116 92.3598L98.2628 79.4212L102.073 79.6823ZM97.0216 96.0035C97.0602 95.44 97.2718 94.981 97.6563 94.6265C98.0516 94.2624 98.5729 94.1026 99.2203 94.147C99.8578 94.1906 100.347 94.4197 100.689 94.8343C101.032 95.2386 101.184 95.7225 101.145 96.286C101.108 96.829 100.892 97.2825 100.497 97.6466C100.102 98.0004 99.5861 98.1555 98.9487 98.1118C98.3012 98.0675 97.8062 97.8431 97.4637 97.4388C97.1318 97.0249 96.9844 96.5465 97.0216 96.0035Z",
    fill: "#B4BDC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1620_26567",
    x: 2.99987,
    y: 72.0306,
    width: 117.165,
    height: 56.6516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5023,
    result: "effect1_foregroundBlur_1620_26567"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1620_26567",
    x: 84.4268,
    y: 73.334,
    width: 39.3154,
    height: 44.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1620_26567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1620_26567",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.c673f6619448506b9a19a61b977c28e4.svg";
export { ForwardRef as ReactComponent };